import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-196" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-197" data-mp="j76t2jrmpvor">
        <SectionHeading id="summary-title" data-id="element-198" data-mp="j8hw2hd92zet">Everything <span className="text-accent" data-id="element-199" data-mp="j5c6z24mfxj3">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-primary/60 bg-surface sm:grid-cols-2" data-id="element-200" data-mp="1gufb24sf8mm0">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-primary/15 p-4 sm:odd:border-r" data-id="element-201" data-mp="16whmthakapte">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary" data-id="element-202" data-mp="12vpeqrdfeqyp">
                <CheckIcon className="h-3.5 w-3.5 text-foreground" aria-hidden="true" data-id="element-203" data-mp="3ro1jgzr8pnly" />
              </span>
              <b className="text-sm text-foreground" data-id="element-204" data-mp="3nklsaixxwfgn">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}